module.exports = __webpack_public_path__ + "img/erqi4.468396ef.png";